import React from 'react';

/**
 * A custom icon for indicating wired screenshare.
 *
 * @returns {ReactElement}
 */
export default function WireledScreenshareIcon() {
    return <i className = 'material-icons'>wired_screen_share</i>;
}
